import { ESdChangeReason, IWorkFlow } from "@kuika/kuika-cl-model";
import {
  EWFDueUnit,
  EWFEventTag,
  EWFEventType,
  EWFNodeType,
  IWFEvent
} from "@kuika/kuika-cl-model/src/models/workflow";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import { WorkflowDue } from "../wf-utils/workflow-due";

export interface IWorkFlowIntermediateCatchEventPropertiesState {
  intermediateCatchEvent: IWFEvent | undefined;
  loading: boolean;
}

export interface IWorkFlowIntermediateCatchEventPropertiesProps {
  selectedNodeId: string | undefined;
}

class WorkFlowIntermediateCatchEventProperties extends PureSdComponent<
  IWorkFlowIntermediateCatchEventPropertiesProps & IWithSDProps & IWithContextProp,
  IWorkFlowIntermediateCatchEventPropertiesState
> {
  constructor(props: IWorkFlowIntermediateCatchEventPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
    const wf: IWorkFlow | undefined = this.props.sd.selectedWf;
    const intermediateCatchEvent = this.props.sd.findNodeRecursively(
      this.props.selectedNodeId!,
      EWFNodeType.Event,
      wf!
    ) as IWFEvent | undefined;
    if (intermediateCatchEvent && !intermediateCatchEvent.dueIn) {
      intermediateCatchEvent.dueIn = { dueUnit: EWFDueUnit.Days, dueValue: 1 };
    }
    this.state = { intermediateCatchEvent, loading: false };
  }

  getEventTagText = (eventTag: EWFEventTag | undefined) => {
    switch (eventTag) {
      case EWFEventTag.Timer:
        return "Timer";
      case EWFEventTag.Message:
        return "Message";
      case EWFEventTag.Signal:
        return "Signal";
      case EWFEventTag.Undefined:
      default:
        return "";
    }
  };

  dueChangeHandler = async (value, type) => {
    const { intermediateCatchEvent } = this.state;
    if (type === "unit") {
      intermediateCatchEvent!.dueIn!.dueUnit = value as EWFDueUnit;
    } else if (type === "value") {
      intermediateCatchEvent!.dueIn!.dueValue = value;
    }
    const wf: IWorkFlow | undefined = this.props.sd.selectedWf;
    const selectedEvent = wf?.nodes?.events.find((s) => s.id == this.props.selectedNodeId);
    if (wf && selectedEvent && selectedEvent.eventType === EWFEventType.Intermediate) {
      selectedEvent.dueIn = intermediateCatchEvent!.dueIn;
      this.setState({ intermediateCatchEvent });
      await this.props.sd.saveWorkFlow(wf);
    }
  };

  render() {
    const { intermediateCatchEvent } = this.state;
    return (
      <>
        <div className="kuika__workflow__fields__header" style={{ border: "none" }}>
          <div className="kuika__workflow__fields__header-top">
            <span className="kuika_workflow-properties__property-type">
              {this.getEventTagText(intermediateCatchEvent?.eventTag)} Intermediate Event
            </span>
          </div>
          <span style={{ fontSize: 11, color: "var(--dark-6)" }}>{}</span>
        </div>
        <div
          style={{
            height: "calc(100vh - 456px)",
            overflowY: "scroll",
            overflowX: "hidden"
          }}
        >
          <div className="kuika_workflow-properties__section">
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <WorkflowDue
                  id="intermediate-catch-event-due"
                  key={intermediateCatchEvent?.id}
                  due={intermediateCatchEvent?.dueIn}
                  onDueUnitChange={(val) => this.dueChangeHandler(val, "unit")}
                  onDueValueChange={(val) => this.dueChangeHandler(val, "value")}
                  loading={this.state.loading}
                ></WorkflowDue>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.SaveWorkflow) {
      return true;
    }
    return false;
  };
}

const workFlowIntermediateCatchEventProperties = withContext<IWorkFlowIntermediateCatchEventPropertiesProps>(
  withSD<IWorkFlowIntermediateCatchEventPropertiesProps>(WorkFlowIntermediateCatchEventProperties)
);
export { workFlowIntermediateCatchEventProperties as WorkFlowIntermediateCatchEventProperties };
